import { FC, useState, useEffect, useRef } from 'react';
import { TelegramShareButton, TelegramIcon, PinterestShareButton, PinterestIcon, ViberShareButton, ViberIcon, WhatsappShareButton, WhatsappIcon, VKShareButton, VKIcon, MailruShareButton, MailruIcon, EmailShareButton, EmailIcon } from 'next-share';
import { ABSOLUTE_URL } from '@/helpers/variables';
import styles from './SocialsBar.module.scss';

interface ISocialsBar {
  bookLink: string;
}

const SocialsBar: FC<ISocialsBar> = ({ bookLink }) => {
  const SOCIAL_ICONS_SIZE = 25;
  const absoluteBookLink = `${ABSOLUTE_URL}${bookLink}`;

  const [linkNote, setLinkNote] = useState(false);
  const [popupActive, setPopupActive] = useState(false);

  const socialsRef = useRef<HTMLDivElement>(null);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(absoluteBookLink);
    setLinkNote(true);
    setTimeout(() => setLinkNote(false), 4000);
  };

  useEffect(() => {
    const socialsClick = (e: any) => {
      if (socialsRef.current) {
        socialsRef.current.contains(e.target) || setPopupActive(false);
      }
    };
    document.addEventListener('click', socialsClick);

    const handleEscSocials = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setPopupActive(false);
      }
    };

    window.addEventListener('keydown', handleEscSocials);

    return () => {
      window.removeEventListener('keydown', handleEscSocials);
      document.removeEventListener('click', socialsClick);
    };
  }, []);

  return (
    <>
      {bookLink && (
        <div className={styles.socials} ref={socialsRef}>
          <div className={styles.socials__btn} onClick={() => setPopupActive(true)}>
            Поделиться
          </div>
          {popupActive && (
            <div className={styles.socials__popup}>
              <span className={styles.socials__closeBtn} onClick={() => setPopupActive(false)}></span>
              <p className={styles.socials__title}>Поделиться:</p>
              <ul className={styles.socials__wrap}>
                <li className={styles.socials__item} title="Telegram">
                  <TelegramShareButton url={absoluteBookLink} title={`${ABSOLUTE_URL}`}>
                    <TelegramIcon size={SOCIAL_ICONS_SIZE} round />
                  </TelegramShareButton>
                </li>

                <li className={styles.socials__item} title="Vkontakte">
                  <VKShareButton url={absoluteBookLink} image={'./next-share.png'}>
                    <VKIcon size={SOCIAL_ICONS_SIZE} round />
                  </VKShareButton>
                </li>

                <li className={styles.socials__item} title="WhatsApp">
                  <WhatsappShareButton url={absoluteBookLink} title={`${ABSOLUTE_URL}`} separator=":: ">
                    <WhatsappIcon size={SOCIAL_ICONS_SIZE} round />
                  </WhatsappShareButton>
                </li>

                <li className={styles.socials__item} title="Viber">
                  <ViberShareButton url={absoluteBookLink} title={`${ABSOLUTE_URL}`}>
                    <ViberIcon size={SOCIAL_ICONS_SIZE} round />
                  </ViberShareButton>
                </li>

                <li className={styles.socials__item} title="Pinterest">
                  <PinterestShareButton url={absoluteBookLink} media={`${ABSOLUTE_URL}`}>
                    <PinterestIcon size={SOCIAL_ICONS_SIZE} round />
                  </PinterestShareButton>
                </li>

                <li className={`${styles.socials__item} ${styles.socials__item_mailru}`} title="Mой Мир mail.ru">
                  <MailruShareButton url={absoluteBookLink} title={`${ABSOLUTE_URL}`}>
                    <MailruIcon size={SOCIAL_ICONS_SIZE} round />
                  </MailruShareButton>
                </li>

                <li className={styles.socials__item} title="Почта">
                  <EmailShareButton url={absoluteBookLink} subject={`Книга с сайта ${ABSOLUTE_URL}`} body="body">
                    <EmailIcon size={SOCIAL_ICONS_SIZE} round />
                  </EmailShareButton>
                </li>
              </ul>
              <p className={linkNote ? `${styles.socials__copyLink} ${styles.socials__copyLink_note}` : `${styles.socials__copyLink}`} onClick={handleCopyLink}>
                {linkNote ? 'Cсылка скопирована' : 'Скопировать сылку'}
              </p>
            </div>
          )}
        </div>
      )}
    </>
  );
};
export default SocialsBar;
